<div class="mc-formis-form-array" [id]="'mc-formis-form-array '+field.key">

  <div class="mc-formis-form-array-header" style="display: none;">
    <b class="text-decoration-underline">{{getOfProps('label')}}</b>
  </div>

  <div class="mc-formis-form-array-content">
    @for (currentField of field.fieldGroup; track field; let i = $index) {
    <div class="mc-formis-form-array-row-wrraper  mc-mt-4"
      [id]="'mc-formis-form-array '+field.key + '-' +currentField.key">
      <div class="mc-formis-form-array-row">
        <div class="mc-formis-form-array-row-header">

          <b>{{getRowTitle(i)}}</b>
          <i class="icon-Color-Overlay  fw-bolder" (click)="toggleRow(currentField)" tabindex="0" role="button"
            (keyup.enter)="toggleRow(currentField)" [ngClass]="{'rotated-180': !getOfProps('isCloseRow',currentField)}"
            [id]="'mc-formis-form-array '+field.key + '-' +currentField.key + 'ToggleRow'"></i>

        </div>

        @if(!getOfProps('isCloseRow',currentField)){
        <div class="mc-formis-form-array-row-content">
          <formly-field class="col-md-10" [field]="currentField"></formly-field>

        </div>


        <div class="mc-formis-form-array-row-footer  mc-mt-3">
          @if(isShowDeleteRow()){
          <mc-button [label]="formisRepeatText.deleteRow" (click)="deleteRow(i)"
            class="mi-white-button  mc-formis-form-array-delete-row" [icon]="'icon-trash-2'"
            [id]="'mc-formis-form-array '+field.key + '-' +currentField.key + 'DeleteRow'">
          </mc-button>
          }
        </div>
        }
      </div>


    </div>
    }
    @if(isShowAddRow()){
    <mc-button [label]="'+ '+getAddButtonText()" (click)="addRow()"
      class="mi-white-button  mc-formis-form-array-add-row" [id]="'mc-formis-form-array '+field.key + 'AddRow'">
    </mc-button>
    }
  </div>



</div>


<mc-dialog [dialogProperties]="dialogProperties"></mc-dialog>

<ng-template #dialogContentTemplate>
  <div class="d-flex flex-column align-items-center p-3  mc-formis-form-array-dialog mi-delete-dialog">

    <div class="d-flex flex-column align-items-center text-center">
      <b class=" mi-delete-dialog-contentTextPart1">
        {{formisRepeatText.deleteDialog.contentTextPart1}}</b>
      <span class=" mi-delete-dialog-contentTextPart2">
        {{formisRepeatText.deleteDialog.contentTextPart2}}</span>

    </div>

  </div>
</ng-template>